import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { createBooking } from '../lib/api';
import { usePageMeta } from '../hooks/use-page-meta';
import { ContactForm } from '../components/contact/ContactForm';
import { ContactInfo } from '../components/contact/ContactInfo';
import { ContactSuccess } from '../components/contact/ContactSuccess';

const emptyForm = (sessionType = '', packageType = '') => ({
  name: '',
  email: '',
  phone: '',
  sessionType,
  packageType,
  preferredDate: '',
  message: ''
});

export const ContactPage = () => {
  const location = useLocation();
  usePageMeta({
    title: 'Book a Session',
    description: 'Book your family, newborn, maternity or couples photo session in Dubai with Elina K. Classic from 1,000 AED, Signature from 1,400 AED.',
    path: '/contact'
  });
  const [formData, setFormData] = useState(() => emptyForm(location.state?.category || '', location.state?.packageType || ''));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await createBooking(formData);
      setIsSubmitted(true);
    } catch (err) {
      toast.error('Something went wrong sending your message. Please try again or email me directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReset = () => {
    setIsSubmitted(false);
    setFormData(emptyForm());
  };

  if (isSubmitted) return <ContactSuccess onReset={handleReset} />;

  return (
    <div className="min-h-screen bg-[#1a1a1a]" style={{ paddingTop: '100px' }} data-testid="contact-page">
      <div className="revolt-container section-spacing">
        <div className="text-center mb-lg">
          <h1 className="section-title">Get In Touch</h1>
          <p className="subtitle max-w-2xl mx-auto">
            Ready to book your session? Fill out the form below and I'll get back to you shortly.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="fade-in-up">
            <ContactForm
              formData={formData}
              isSubmitting={isSubmitting}
              onChange={handleChange}
              onSubmit={handleSubmit}
            />
          </div>
          <div className="fade-in-up stagger-1 lg:pl-8">
            <ContactInfo />
          </div>
        </div>
      </div>
    </div>
  );
};
